export default {
	"billContent": {
		"isRequired": "Is it required",
		"limit": "limit value",
		"defaultValue": "Defaults",
		"fixedValue": "Fixed value",
		"otherStyle": "other",
		"RangeValue": "Value range"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/product/product.js